var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.status)?_c('vs-chip',{class:_vm.$style.container,attrs:{"color":_vm.status.color}},[_vm._v("\n  "+_vm._s(_vm.status.name)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }